import { render, staticRenderFns } from "./BookingDates.vue?vue&type=template&id=230e6170&scoped=true&"
import script from "./BookingDates.vue?vue&type=script&lang=ts&"
export * from "./BookingDates.vue?vue&type=script&lang=ts&"
import style0 from "./BookingDates.vue?vue&type=style&index=0&id=230e6170&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e6170",
  null
  
)

export default component.exports